import React from 'react';
import AirportIcon from '../assets/cars/airport/AirportIcon';
import BuildingIcon from '../assets/cars/building/BuildingIcon';
import CabIcon from '../assets/cars/cabicon/CabIcon';
import CarWithBgIcon from '../assets/cars/carwithbg/CarWithBgIcon';
import LocationIcon from '../assets/cars/location/LocationIcon';
import NavArrowIcon from '../assets/cars/nav-arrow/NavArrowIcon';
import ReloadIcon from '../assets/cars/reload/ReloadIcon';
import SwapIcon from '../assets/cars/swap/SwapIcon';
import ArrowLeftIcon from '../assets/cars/arrow-left/ArrowLeftIcon';
import ArrowRightIcon from '../assets/cars/arrow-right/ArrowRightIcon';
import ArrowTailDownIcon from '../assets/cars/arrow-tail-down/ArrowTailDownIcon';
import ArrowTailUpIcon from '../assets/cars/arrow-tail-up/ArrowTailUpIcon';
import GoSafeIcon from '../assets/cars/go-safe/go-safe';
import IconBack from '../assets/cars/Icon-back/Icon-back';
import LobCabIcon from '../assets/cars/LobCabIcon/LobIcon';
import FilterSearchIcon from '../assets/cars/filter-search/filter-search';
import AckoIcon from '../assets/cars/acko-logo/acko-logo';
import GoIcon from '../assets/cars/go-icon/go-icon';
import NewArrowRightIcon from '../assets/cars/new-arrow-right/new-arrow-right';
import NavigationDownCircle from '../assets/cars/NavigationDownCircle/NavigationDownCircle';
import IconNavigationCheck from '../assets/cars/icon-navigation-check/icon-navigation-check';
import Promocode from '../assets/cars/promo-code/promo-code';
import AcIcon from '../assets/cars/acIcon/acIcon';
import NavigationDownIcon from '../assets/cars/navigation-down/navigation-down';
import CrossIcon from '../assets/cars/cross-icon/cross-icon';
import CloseIcon from '../assets/cars/close-icon/close-icon';
import GreenTickIcon from '../assets/cars/green-tick/green-tick';
import ClosePopupIcon from '../assets/cars/crossPopupIcon/crossPopupIcon';
import BenefitsIcon from '../assets/cars/benefits-tick/benefits-tick';
import CabIconNoresults from '../assets/cars/cars-icon-noresults/car-icon-noresults';
import TickIcon from '../assets/cars/tickIcon/TickIcon';
import SafetyCheckIcon from '../assets/cars/safety-check/SafeCheck';
import LightingIcon from '../assets/cars/lighting-icon/lighting-icon';
import OfferIcon from '../assets/cars/offerIcon/OfferIcon';
import RydeAssured from '../assets/cars/rydebanner/rydeAssuured.svg';
import PrevBtn from '../assets/cars/rydebanner/prevBtn.svg';
import NextBtn from '../assets/cars/rydebanner/nextBtn.svg';
import NextBtnInactive from '../assets/cars/rydebanner/nextBtnInactive.svg';
import PrevBtnInactive from '../assets/cars/rydebanner/prevBtnInactive.svg';
import Sanitization from '../assets/cars/rydebanner/sanitization.svg';
import Professional from '../assets/cars/rydebanner/professional.svg'
import Pricing from '../assets/cars/rydebanner/pricing.svg';
import GPS from '../assets/cars/rydebanner/gps.svg';
import Sound from '../assets/cars/rydebanner/Sound.svg';
import TravelKit from '../assets/cars/rydebanner/TravelKit.svg';
import GoCashWhiteTick from "../assets/cars/goCash/goCashWhiteTick.svg";

type IconProps = {
  name: string;
  styleProps?: {
    [k: string]: string; // better typescript – 🐨 css properties
  };
};

const Icon = ({name = '', styleProps}: IconProps) => {
  if (!name) return null;
  switch (name) {
    case "GoCashWhiteTick":
      return <GoCashWhiteTick />;
    case 'AirportIcon':
      return <AirportIcon {...styleProps} />;
    case 'BuildingIcon':
      return <BuildingIcon {...styleProps} />;
    case 'CabIcon':
      return <CabIcon {...styleProps} />;
    case 'CarWithBgIcon':
      return <CarWithBgIcon {...styleProps} />;
    case 'LocationIcon':
      return <LocationIcon {...styleProps} />;
    case 'NavArrowIcon':
      return <NavArrowIcon {...styleProps} />;
    case 'ReloadIcon':
      return <ReloadIcon {...styleProps} />;
    case 'SwapIcon':
      return <SwapIcon {...styleProps} />;
    case 'ArrowLeftIcon':
      return <ArrowLeftIcon {...styleProps} />;
    case 'ArrowRightIcon':
      return <ArrowRightIcon {...styleProps} />;
    case 'ArrowTailDownIcon':
      return <ArrowTailDownIcon {...styleProps} />;
    case 'ArrowTailUpIcon':
      return <ArrowTailUpIcon {...styleProps} />;
    case 'GosafeIcon':
      return <GoSafeIcon {...styleProps} />;
    case 'Iconback':
      return <IconBack {...styleProps} />;
    case 'LobIcon':
      return <LobCabIcon {...styleProps} />;
    case 'FilterSearch':
      return <FilterSearchIcon {...styleProps} />;
    case 'AckoIcon':
      return <AckoIcon {...styleProps} />;
    case 'GOIcon':
      return <GoIcon {...styleProps} />;
    case 'NewArrowRightIcon':
      return <NewArrowRightIcon {...styleProps} />;
    case 'NavigationDownCircle':
      return <NavigationDownCircle {...styleProps} />;
    case 'IconNavigationCheck':
      return <IconNavigationCheck {...styleProps} />;
    case 'Promocode':
      return <Promocode {...styleProps} />;
    case 'AcIcon':
      return <AcIcon {...styleProps} />;
    case 'NavigationDownIcon':
      return <NavigationDownIcon {...styleProps} />;
    case 'CrossIcon':
      return <CrossIcon {...styleProps} />;
    case 'CloseIcon':
      return <CloseIcon {...styleProps} />;
    case 'GreenTickIcon':
      return <GreenTickIcon {...styleProps} />;
    case 'ClosePopupIcon':
      return <ClosePopupIcon {...styleProps} />;
    case 'BenefitsIcon':
      return <BenefitsIcon {...styleProps} />;
    case 'CabIconNoresults':
      return <CabIconNoresults {...styleProps} />;
    case 'TickIcon':
      return <TickIcon {...styleProps} />;
    case 'SafetyCheck':
      return <SafetyCheckIcon {...styleProps} />;
    case 'Lighting':
      return <LightingIcon {...styleProps} />
    case 'Offer':
      return <OfferIcon {...styleProps} />
    case 'RydeAssured':
      return <RydeAssured />
    case 'PrevBtn':
      return <PrevBtn /> 
    case 'NextBtn':
      return <NextBtn /> 
    case 'Professional':
      return <Professional /> 
    case 'Sanitization':
      return <Sanitization /> 
    case 'Pricing':
      return <Pricing /> 
    case 'GPS':
      return <GPS /> 
    case 'Sound':
      return <Sound /> 
    case 'TravelKit':
      return <TravelKit /> 
    case 'NextBtnInactive':
      return <NextBtnInactive /> 
    case 'PrevBtnInactive':
      return <PrevBtnInactive /> 
    default:
      return null;
  }
};

export default Icon;
